// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HJOh","delete":"styles_delete__1d6UM","update":"styles_update__T08at","add":"styles_add__3r73A"};